module.exports = __webpack_public_path__ + "img/blue.f9a89c4a.png";